module["exports"] = [
  "com",
  "mx",
  "info",
  "com.mx",
  "org",
  "gob.mx"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/es_MX/internet/domain_suffix.js
 ** module id = 539
 ** module chunks = 0
 **/